var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _linearGradient4, _path9, _linearGradient5, _path10, _linearGradient6, _path11, _linearGradient7, _path12, _linearGradient8, _path13, _linearGradient9, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivableAdjustmentsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: -3570.619,
    y1: -248.12,
    x2: -3569.619,
    y2: -248.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 43.258,
    y1: 45.36,
    x2: 64.143,
    y2: 45.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.076 45.381c2.432.943 2.484 5.618-1.53 6.383-4.759.901-6.457-3.228-5.953-6.289.514-3.061 3.092-6.603 8.5-6.645 4.161-.031 7.61 2.736 9.8 5.125",
    fill: "none",
    stroke: "url(#SVGID_1_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 114.008,
    y1: 40.718,
    x2: 126.23,
    y2: 40.718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.98 43.149a4.86 4.86 0 10-9.722 0",
    fill: "none",
    stroke: "url(#SVGID_2_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M90.998 33.278s9.236-2.478 16.93-.433M129.618 31.65c3.889 3.249 7.054 7.148 9.245 11.498"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.988 71.627v-.01c-2.054-4.287-3.197-8.993-3.197-13.93 0-4.863 1.101-9.496 3.103-13.731 2.002-4.235 4.905-8.071 8.5-11.299 0 0 6.945-7.111 19.412-9.863 2.793-.654 6.729-1.132 10.272-1.132 4.979 0 9.758.765 14.181 2.18M138.863 43.149h7.777c2.956 0 5.377 2.421 5.377 5.377v15.198c0 2.956-2.421 5.377-5.377 5.377h-6.383"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M115.258 23.842l19.423-6.247-5.063 14.055M72.264 102.7h-2.546c-3.752 0-6.823-3.071-6.823-6.823V71.412M123.405 102.703h1.158c3.753 0 6.824-3.071 6.824-6.824l.056-13.771c3.91-3.71 6.949-8.123 8.815-13.008M129.618 31.65c3.889 3.249 7.054 7.148 9.245 11.498"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.988 71.627v-.01c-2.054-4.287-3.197-8.993-3.197-13.93 0-4.863 1.101-9.496 3.103-13.731 2.002-4.235 4.905-8.071 8.5-11.299 0 0 6.945-7.111 19.412-9.863 2.793-.654 6.729-1.132 10.272-1.132 4.979 0 9.758.765 14.181 2.18M138.863 43.149h7.777c2.956 0 5.377 2.421 5.377 5.377v15.198c0 2.956-2.421 5.377-5.377 5.377h-6.383"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M115.258 23.842l19.423-6.247-5.063 14.055M72.264 102.7h-2.546c-3.752 0-6.823-3.071-6.823-6.823V71.412M123.405 102.703h1.158c3.753 0 6.824-3.071 6.824-6.824l.056-13.771c3.91-3.71 6.949-8.123 8.815-13.008M92.623 64.316H72.741v18.26l.207 44.203v6.4h50.094V64.316H102.72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M113.771 87.216l-2.535-2.535-5.844 5.844.13 2.595 2.405-.06zM105.74 92.967l-6.291 6.291"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: -754.308,
    y1: -767.311,
    x2: -748.637,
    y2: -767.311,
    gradientTransform: "rotate(45.001 -1387.452 686.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 90.475 108.3)",
    fill: "none",
    stroke: "url(#SVGID_3_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 1.491,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M82.018 106.209h16.916v4.18H82.018z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: -727.954,
    y1: -700.162,
    x2: -686.799,
    y2: -700.162,
    gradientTransform: "rotate(45.001 -1271.078 671.741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.986 112.901L93.805 93.72a6.565 6.565 0 00-8.866-8.866l4.579 4.579-.043 2.879-2.871.036-4.519-4.519a6.56 6.56 0 001.272 7.474 6.56 6.56 0 007.474 1.273l19.24 19.24 2.915-2.915z",
    fill: "none",
    stroke: "url(#SVGID_4_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 1.491,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 80.695,
    y1: 99.958,
    x2: 114.6,
    y2: 99.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M113.771 87.216l-2.535-2.535-5.844 5.844.13 2.595 2.405-.06z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 80.695,
    y1: 99.958,
    x2: 114.6,
    y2: 99.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M105.74 92.967l-6.291 6.291"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 80.695,
    y1: 99.958,
    x2: 114.6,
    y2: 99.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 90.475 108.3)",
    fill: "none",
    stroke: "url(#SVGID_7_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M82.018 106.209h16.916v4.18H82.018z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d",
    gradientUnits: "userSpaceOnUse",
    x1: 80.695,
    y1: 99.958,
    x2: 114.6,
    y2: 99.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.986 112.901L93.805 93.72a6.565 6.565 0 00-8.866-8.866l4.579 4.579-.043 2.879-2.871.036-4.519-4.519a6.56 6.56 0 001.272 7.474 6.56 6.56 0 007.474 1.273l19.24 19.24 2.915-2.915z",
    fill: "none",
    stroke: "url(#SVGID_8_fb87c6c40b5985e18451d145495130b506ff850b65ce9d95e9daf91692e02b5d)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M93.248 56.084l.232 20.757 8.851-2.45-.018-19.592z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivableAdjustmentsMenu);
export default __webpack_public_path__ + "static/media/receivableAdjustmentsMenu.bddcfa3431d9543234478a491e199678.svg";
export { ForwardRef as ReactComponent };